import { motion } from 'framer-motion';

interface EmailDisplayProps {
  email: string;
  onBack: () => void;
  isSubmitting: boolean;
}

const EmailDisplay = ({ email, onBack, isSubmitting }: EmailDisplayProps) => {
  return (
    <motion.div
      layout
      className="mb-6"
      initial={{ opacity: 0 }}
      animate={{ 
        opacity: 1, 
        transition: { delay: 0.1, duration: 0.4 } 
      }}
    >
      <motion.div 
        layout
        transition={{
          layout: { type: "spring", stiffness: 300, damping: 30 }
        }}
        className="flex items-stretch gap-3"
      >
        {/* Back button */}
        <motion.button
          layout
          onClick={onBack}
          className="text-[#694e42] hover:text-[#ff8c42] transition-colors flex-shrink-0"
          disabled={isSubmitting}
          whileHover={{ scale: 1.1, rotate: -10 }}
          whileTap={{ scale: 0.9 }}
          transition={{
            layout: { type: "spring", stiffness: 300, damping: 30 }
          }}
        >
          <motion.div 
            layout
            className="bg-[#fcf9f6] flex items-center justify-center shadow-sm border border-[#e2dad3] hover:border-[#ff8c42]/30 transition-colors rounded-xl h-[42px] w-[42px]"
            transition={{
              layout: { type: "spring", stiffness: 300, damping: 30 }
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 12H5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M12 19L5 12L12 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </motion.div>
        </motion.button>
        
        {/* Email display */}
        <motion.div 
          layout
          transition={{
            layout: { type: "spring", stiffness: 300, damping: 30 }
          }}
          className="relative overflow-hidden rounded-xl bg-gradient-to-r from-[#fcf9f6] to-[#f9f6f4] shadow-sm border border-[#e2dad3] group flex-grow h-[42px]"
        >
          {/* Animated highlight effect */}
          <motion.div
            className="absolute inset-0 bg-gradient-to-r from-[#ff8c42]/0 via-[#ff8c42]/10 to-[#ff8c42]/0"
            initial={{ x: "-100%" }}
            animate={{ x: "200%" }}
            transition={{ duration: 3, repeat: Infinity, repeatType: "loop", ease: "easeInOut" }}
          />
          
          <motion.div 
            layout
            transition={{
              layout: { type: "spring", stiffness: 300, damping: 30 }
            }}
            className="relative z-10 flex items-center h-full px-4"
          >
            <motion.div 
              layout
              transition={{
                layout: { type: "spring", stiffness: 300, damping: 30 }
              }}
              className="mr-3 text-[#ff8c42]"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z" fill="currentColor"/>
              </svg>
            </motion.div>
            <span className="font-medium text-[#694e42] truncate">{email}</span>
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default EmailDisplay;